// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legend-item-wrapper[data-v-0e1607cb]{display:flex;align-items:center;margin-bottom:16px}.legend-label[data-v-0e1607cb]{padding-left:8px;margin-top:8px;margin-right:16px}.legend-icon[data-v-0e1607cb]{width:38px;height:38px;margin-right:8px}", ""]);
// Exports
module.exports = exports;
